export default __webpack_public_path__ + "static/media/logo.a1412333.png";